'use strict';

module.exports = require('./Slider');


//////////////////
// WEBPACK FOOTER
// ./~/rc-slider/lib/index.js
// module id = 1232
// module chunks = 0